import http from '@/http'

export type Response = {
  isQrCodeThrowable?: true
  isFilterTagThrowable?: true
  isCheckInSuccess?: true
  isCheckInAlready?: true
  message: string
  id?: string
  name?: string
  suggestions?: Array<{
    id: number
    name: string
    group: string | null
    email: string
    score: number
    photo: string | null
    confirmationCode?: string
  }>
}

export async function putCheckInFacial (
  photo: File,
  tagFilterList: number[] = []
): Promise<Response> {
  const formData = new FormData()
  formData.append('facial', photo)
  if (tagFilterList.length > 0) {
    formData.append('tags', JSON.stringify(tagFilterList))
  }

  try {
    const response = await http.post('/admin/check-in/facial', formData, {
      validateStatus: () => true
    })

    const { data } = response

    // === 422: ERRO DE VALIDAÇÃO (já fez check-in, tag inválida, etc) ===
    if (response.status === 422) {
      return handleRespondeFail(data.message, data.participant ?? null)
    }

    // === 200: RESPOSTA VÁLIDA ===
    if (response.status === 200) {
      // 1. CHECK-IN AUTOMÁTICO
      if (data.match === true) {
        return handleRespondeSuccess(data.message, data.participant)
      }

      // 2. SUGESTÕES (requires_confirmation)
      if (data.requires_confirmation === true && data.suggestions?.length) {
        return {
          isFilterTagThrowable: true,
          message: data.message || 'Selecione o participante correto',
          suggestions: data.suggestions.map((s: any) => ({
            id: s.id,
            name: s.name,
            email: s.email,
            group: s.group,
            score: s.score,
            photo: s.photo
          }))
        }
      }

      // 3. NÃO RECONHECIDO (sem sugestões)
      return {
        isQrCodeThrowable: true,
        message: data.message || 'Rosto não reconhecido'
      }
    }

    // === ERRO INESPERADO ===
    const exc: any = {
      CODID: 'V8S0N20U',
      response,
      message: data.message || 'Erro desconhecido no check-in facial'
    }
    exc.error = new Error(exc.CODID)
    throw exc
  } catch (error: any) {
    const exc: any = {
      CODID: 'NET_ERR_001',
      message: 'Falha na comunicação com o servidor',
      error
    }
    throw exc
  }
}

// === MANTÉM SUAS FUNÇÕES EXISTENTES ===
function handleRespondeFail (
  message: string,
  participant?: { id: number; name: string }
): Response {
  if (!participant) {
    return {
      isQrCodeThrowable: true,
      message
    }
  }
  if (message === 'já fez o check-in') {
    return {
      isCheckInAlready: true,
      message,
      name: participant.name,
      id: '' + participant.id
    }
  }
  return {
    isFilterTagThrowable: true,
    message,
    name: participant.name,
    id: '' + participant.id
  }
}

function handleRespondeSuccess (
  message: string,
  participant: { id: number; name: string }
): Response {
  return {
    isCheckInSuccess: true,
    message,
    name: participant.name,
    id: '' + participant.id
  }
}
